var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isAuthenticationGranted)?_c('div'):_vm._e(),(_vm.isAuthenticationGranted)?_c('div',{staticClass:"header_user"},[_c('span',{staticStyle:{"text-wrap":"nowrap"}},[_c('b-icon',{attrs:{"icon":"person-fill"}}),_vm._v(" "+_vm._s(_vm.userName)+" ")],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }